import React from 'react';
import CaseStudyProjectGridCardItem from './CaseStudyProjectGridCardItem';
import styled, { css } from 'styled-components';
import Container from '../container';
import mq from '../../utils/mq';

const CaseStudyProjectGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 56px;
  grid-column-gap: 20px;
  ${mq.mobile(css`
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 32px;
  `)};
`;

export default function CaseStudyProjectGrid({
  caseStudies
}: {
  caseStudies: any[];
}) {
  return (
    <Container>
      <CaseStudyProjectGridContainer>
        {caseStudies.map((caseStudy) => (
          <CaseStudyProjectGridCardItem
            key={caseStudy.full_slug}
            caseStudy={caseStudy}
          />
        ))}
      </CaseStudyProjectGridContainer>
    </Container>
  );
}
